<!--
 * @Autor: 李建鹏
 * @Date: 2022-07-28 19:30:00
 * @LastEditTime: 2022-10-13 11:51:48
 * @Description: 近期价格走势
-->
<template>
  <div class="trend_chart">
    <div class="title">近期价格走势</div>
    <div class="trend_chart-wrapper">
      <div id="trendEchart"></div>
    </div>
  </div>
</template>

<script>
  import { chartConfig } from './chart'
  export default {
    components: {},
    props: {
      // $ 趋势价格数据
      chartData: {
        type: [Array, Object, String],
        default: () => null,
      },
      // $ 当前商品原价 fen
      originalPrice: {
        type: [String, Number],
        default: () => 0,
      },
    },
    data() {
      return {
        trendChart: null,
        priceImg:
          'image://https://pic5.zhuanstatic.com/zhuanzh/c6c2647e-0ccb-4f3a-94f0-10f906df8fe0.png',
      }
    },
    watch: {},
    mounted() {
      // this.$nextTick(() => this.getLoadEcharts())
      setTimeout(() => {
        this.getLoadEcharts()
      }, 100)
    },
    methods: {
      async getLoadEcharts() {
        if (!this.chartData || !window.echarts) return
        const myChart = echarts.init(document.getElementById('trendEchart'))
        const formatYData = [] // $ 处理Y轴数据
        const todayData = [] // $ 圆点动画及今天标识需要用到的数据
        this.chartData.yData &&
          this.chartData.yData.forEach((item) => {
            formatYData.push((item && (item * 100) / 10000) || 0)
            todayData.push('-')
          })
        // $ 获取当前日期的价格在数据中的索引
        const currentIdx =
          this.chartData.xData && this.chartData.xData.indexOf(this.chartData.curDateString)
        todayData[currentIdx] = formatYData[currentIdx]
        // $ 今天之前的价格 处理渐变的问题
        const defaultYData = formatYData.slice(0, currentIdx + 1)
        // $ 未来价格走势数据
        const markPointArr = [].concat(
          formatYData.slice(0, currentIdx).map(() => '-'),
          formatYData.slice(currentIdx)
        )
        const option = {
          ...chartConfig({
            xData: this.chartData.xData,
            yData: formatYData,
            platform: this.chartData.platform,
            conditionIdx: currentIdx,
          }),
          series: this.serisFormatter({ defaultYData, markPointArr, todayData }, echarts),
        }

        myChart.setOption(option, true)
      },
      // $ 设置图形样式
      serisFormatter({ defaultYData, markPointArr, todayData }, echarts) {
        return [
          {
            name: '价格走势',
            type: 'line',
            // symbol: 'circle',
            data: defaultYData,
            showAllSymbol: true,
            symbolSize: 7,
            itemStyle: {
              color: 'rgba(255, 51, 51, 1)',
            },
            lineStyle: {
              width: 1,
              color: 'rgba(255, 51, 51,1)',
            },
          },
          {
            name: '明日走势',
            type: 'line',
            smooth: true,
            lineStyle: {
              // type: 'dashed',
              width: 1,
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 1,
                    color: 'rgba(255, 51, 51,1)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(255,255,255, 0)',
                  },
                ],
                false
              ),
            },
            symbol: 'none',
            data: markPointArr,
          },
          {
            name: '今天价格',
            z: 9999,
            type: 'effectScatter',
            rippleEffect: {
              number: 2,
              period: 1,
              scale: 3.2,
              brushType: 'fill',
            },
            smooth: true,
            symbol: 'circle',
            showAllSymbol: true,
            symbolSize: 5,
            label: {
              show: false,
              position: 'bottom',
            },
            itemStyle: {
              normal: {
                color: 'rgba(255,51,51, 0.73)',
                borderWidth: 10,
                shadowColor: 'rgba(255,51,51, 0.53)',
                shadowBlur: 40,
                borderColor: 'rgba(255,236,236,0.15)',
              },
            },
            lineStyle: {
              type: 'dashed',
              width: 1,
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 1,
                    color: 'rgba(255, 51, 51,1)',
                  },
                  {
                    offset: 0,
                    color: 'rgba(255,255,255, 0)',
                  },
                ],
                false
              ),
            },
            markPoint: {
              data: [
                {
                  type: 'max',
                },
              ],
              zlevel: 99999,
              symbol: this.priceImg,
              symbolSize: [30, 22], // 可以根据数值大小设置宽度
              // symbolSize: [56, 40], // 可以根据数值大小设置宽度
              symbolOffset: [0, 20], // 设置markpoint图标的位置

              label: {
                normal: {
                  padding: [25, 10, 20, 0],
                  fontSize: 14,
                  color: '#FF9200',
                  align: 'center',
                  offset: [2, 0],
                  formatter: `{a| 今天}`,
                  rich: {
                    a: {
                      fontSize: 10,
                      color: '#fff',
                      backgroundColor: 'rgba(255, 51, 51,1)',
                    },
                  },
                },
                emphasis: {
                  show: true,
                },
              },
            },
            // symbol: 'none',
            data: todayData,
          },
        ]
      },
    },
    beforeDestory() {
      if (!this.trendChart) return //页面销毁钩子销毁chart释放资源
      this.trendChart.dispose()
      this.trendChart = null
    },
  }
</script>

<style lang="scss">
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';

  .trend_chart {
    // padding: 60px 0;
    // border: 1px solid #f0f0f0;
    // margin-bottom: 30px;
    &-title {
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 42px;
    }
    &-wrapper {
      width: 100%;
      height: 410px;
      background-color: #fff;
      border-radius: 40px;
      margin-top: -50px;
    }
  }

  #trendEchart {
    width: 100%;
    height: 100%;
  }
</style>
